<script setup lang="ts">
withDefaults(defineProps<{
    presentation?: 'immersive' | 'contained';
    backgroundImageUrl?: string;
    backgroundAlt?: string;
    backgroundFallbackStyle?: Record<string, string>;
}>(), {
    presentation: 'immersive',
    backgroundImageUrl: '',
    backgroundAlt: '',
    backgroundFallbackStyle: () => ({}),
});
</script>

<template>
    <section :class="presentation === 'immersive' ? 'workspace-detail-frame' : 'workspace-detail-contained'">
        <div v-if="presentation === 'immersive'" class="workspace-detail-frame__backdrop" aria-hidden="true">
            <img
                v-if="backgroundImageUrl"
                :src="backgroundImageUrl"
                :alt="backgroundAlt"
                class="absolute inset-0 size-full object-cover"
            >
            <div
                v-else
                class="absolute inset-0 bg-muted"
                :style="backgroundFallbackStyle"
            />
            <div class="workspace-detail-frame__overlay absolute inset-0" />
        </div>

        <div :class="presentation === 'immersive' ? 'workspace-detail-frame__scroll' : 'workspace-detail-contained__content'">
            <slot />
        </div>
    </section>
</template>
